<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>

<div id="innerContainer" class="col-md-10 mt-5">
  @for (text of texts; track text) {
    <div>
      <p>
        {{ text.text1 }}
      </p>
      <p>{{ text.text2 }}</p>
      <p>{{ text.text3 }}</p>
      <strong>{{ text.listTitle }}</strong>
      <ul>
        <li>{{ text.list1 }}</li>
        <li>{{ text.list2 }}</li>
        <li>{{ text.list3 }}</li>
        <li>{{ text.list4 }}</li>
        <li>{{ text.list5 }}</li>
        <li>{{ text.list6 }}</li>
      </ul>
    </div>
  }
  @for (secondList of secondLists; track secondList) {
    <div>
      <strong>{{ secondList.listTitle }}</strong>
      <ul>
        <li>{{ secondList.list1 }}</li>
        <li>{{ secondList.list2 }}</li>
        <li>{{ secondList.list3 }}</li>
        <li>{{ secondList.list4 }}</li>
      </ul>
    </div>
  }
</div>
